class ProductFeatures extends HTMLElement {
  constructor() {
    super();
    this.pins = this.querySelectorAll("[data-pin]");
    this.descriptions = this.querySelectorAll("[data-description]");
  }

  connectedCallback() {
    this.pins.forEach((pin) => {
      pin.addEventListener("click", (e) => {
        const pinIndex = e.currentTarget.dataset.pin;

        this.toggleActive(pinIndex);
      });
    });
  }

  toggleActive(index) {
    this.removeActive();

    this.querySelector(`[data-pin="${index}"]`).classList.add("active");
    this.querySelector(`[data-description="${index}"]`).classList.add("active");
  }

  removeActive() {
    this.pins.forEach((pin) => {
      pin.classList.remove("active");
    });

    this.descriptions.forEach((description) => {
      description.classList.remove("active");
    });
  }
}

if (!customElements.get("product-features")) {
  customElements.define("product-features", ProductFeatures);
}
